<!-- landing.component.html -->
<app-header></app-header>

<div class="landing-page">
  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-container">
      <!-- Left Content -->
      <div class="hero-content">
        <h1 class="hero-title" *ngIf="direction === 'ltr'">
          <span class="highlight">{{
            "LANDING.HERO.FOR_HOWEVER_YOU_GROW" | translate
          }}</span>
        </h1>

        <h1 class="hero-title" *ngIf="direction === 'rtl'">
          <span class="highlight">
            {{ "LANDING.HERO.FOR_HOWEVER_YOU_GROW" | translate }}
          </span>
        </h1>

        <p class="hero-description">
          {{ "LANDING.HERO.DESCRIPTION" | translate }}
        </p>

        <div class="hero-features">
          <div class="feature-item">
            <img
              src="assets/images/checkmark.svg"
              alt="Verified"
              class="feature-icon"
            />

            <div>
              <h4>{{ "LANDING.INSURANCE_GUIDE.FEATURES.0" | translate }}</h4>
            </div>
          </div>
          <div class="feature-item">
            <img
              src="assets/images/checkmark.svg"
              alt="Verified"
              class="feature-icon"
            />

            <div>
              <h4>{{ "LANDING.INSURANCE_GUIDE.FEATURES.1" | translate }}</h4>
            </div>
          </div>
          <div class="feature-item">
            <img
              src="assets/images/checkmark.svg"
              alt="Verified"
              class="feature-icon"
            />
            <div>
              <h4>{{ "LANDING.INSURANCE_GUIDE.FEATURES.2" | translate }}</h4>
            </div>
          </div>
          <div class="feature-item">
            <img
              src="assets/images/checkmark.svg"
              alt="Verified"
              class="feature-icon"
            />

            <div>
              <h4>{{ "LANDING.INSURANCE_GUIDE.FEATURES.3" | translate }}</h4>
            </div>
          </div>
        </div>
      </div>
      <div #quotaSection>
        <app-quota></app-quota>
      </div>
    </div>
  </section>

  <!-- Features Section -->
  <section class="features-section">
    <h2 class="section-title">
      {{ "LANDING.FEATURES.SECTION_TITLE" | translate }}
    </h2>
    <p class="section-subtitle">
      {{ "LANDING.FEATURES.SECTION_SUBTITLE" | translate }}
    </p>

    <div class="features-grid">
      <div class="feature-card icon-blue">
        <div class="icon-wrapper">
          <img
            src="assets/images/payment-options.svg"
            alt="Payment Options"
            class="h-12 cursor-pointer"
          />
        </div>
        <h3>{{ "LANDING.FEATURES.FEATURE_1_TITLE" | translate }}</h3>
        <p>{{ "LANDING.FEATURES.FEATURE_1_DESC" | translate }}</p>
      </div>

      <div class="feature-card">
        <div class="icon-wrapper">
          <img
            src="assets/images/policy-online.svg"
            alt="Policy Online"
            class="h-12 cursor-pointer"
          />
        </div>
        <h3>{{ "LANDING.FEATURES.FEATURE_2_TITLE" | translate }}</h3>
        <p>{{ "LANDING.FEATURES.FEATURE_2_DESC" | translate }}</p>
      </div>

      <div class="feature-card bg-[#D0FAE580]">
        <div class="icon-wrapper">
          <img
            src="assets/images/we-are-here.svg"
            alt="We Are Here"
            class="h-12 cursor-pointer"
          />
        </div>
        <h3>{{ "LANDING.FEATURES.FEATURE_3_TITLE" | translate }}</h3>
        <p>{{ "LANDING.FEATURES.FEATURE_3_DESC" | translate }}</p>
      </div>
    </div>
  </section>

  <!-- Why INA Section -->
  <section class="why-section">
    <h2 class="section-title">{{ "LANDING.WHY_BRAND.TITLE" | translate }}</h2>
    <p class="section-subtitle">
      {{ "LANDING.WHY_BRAND.SUBTITLE" | translate }}
    </p>

    <div class="why-grid">
      <div class="why-card">
        <div class="why-icon">
          <img src="/assets/images/page.svg" alt="Fully Digital" />
        </div>
        <h3>{{ "LANDING.WHY_BRAND.FEATURES.0.TITLE" | translate }}</h3>
        <p>{{ "LANDING.WHY_BRAND.FEATURES.0.DESCRIPTION" | translate }}</p>
      </div>

      <div class="why-card">
        <div class="why-icon">
          <img src="/assets/images/badge.svg" alt="All Providers" />
        </div>
        <h3>{{ "LANDING.WHY_BRAND.FEATURES.1.TITLE" | translate }}</h3>
        <p>{{ "LANDING.WHY_BRAND.FEATURES.1.DESCRIPTION" | translate }}</p>
      </div>

      <div class="why-card">
        <div class="why-icon">
          <img src="/assets/images/heart.svg" alt="Built for Care" />
        </div>
        <h3>{{ "LANDING.WHY_BRAND.FEATURES.2.TITLE" | translate }}</h3>
        <p>{{ "LANDING.WHY_BRAND.FEATURES.2.DESCRIPTION" | translate }}</p>
      </div>

      <div class="why-card">
        <div class="why-icon">
          <img src="/assets/images/charge.svg" alt="Tailored Plans" />
        </div>
        <h3>{{ "LANDING.WHY_BRAND.FEATURES.3.TITLE" | translate }}</h3>
        <p>{{ "LANDING.WHY_BRAND.FEATURES.3.DESCRIPTION" | translate }}</p>
      </div>

      <div class="why-card">
        <div class="why-icon">
          <img src="/assets/images/stock.svg" alt="Faster Quotes" />
        </div>
        <h3>{{ "LANDING.WHY_BRAND.FEATURES.4.TITLE" | translate }}</h3>
        <p>{{ "LANDING.WHY_BRAND.FEATURES.4.DESCRIPTION" | translate }}</p>
      </div>

      <div class="why-card">
        <div class="why-icon">
          <img src="/assets/images/clock.svg" alt="Faster Quotes" />
        </div>
        <h3>{{ "LANDING.WHY_BRAND.FEATURES.5.TITLE" | translate }}</h3>
        <p>{{ "LANDING.WHY_BRAND.FEATURES.5.DESCRIPTION" | translate }}</p>
      </div>
    </div>
  </section>

  <!-- Partner Section -->
  <section class="partner-section">
    <h2 class="partner-title">
      {{ "LANDING.PARTNER_SECTION.TITLE" | translate }}
    </h2>
    <p class="partner-description">
      {{ "LANDING.PARTNER_SECTION.SUBTITLE" | translate }}
    </p>
    <p class="partner-subdescription">
      {{ "LANDING.PARTNER_SECTION.DESCRIPTION" | translate }}
    </p>
    <button class="partner-btn" (click)="scrollToQuota()">
      {{ "LANDING.PARTNER_SECTION.CTA" | translate }}
    </button>
  </section>

  <!-- Footer -->
  <app-footer layout="slim"></app-footer>
</div>
